<template>
    <div class="mobile-nav"
         @click="show = false">
        <div class="nav-logo"
             @click="goto">
            <img class="img-logo"
                 src="https://res.ldmnq.com/ldq_website/img/mobile/logo.png"
                 alt="">
            <img class="img-title"
                 src="https://res.ldmnq.com/ldq_website/img/mobile/logo-title.png"
                 alt="">
        </div>
        <div class="nav-menu">
            <img @click.stop="show = !show"
                 src="https://res.ldmnq.com/ldq_website/img/mobile/nav-menu.png"
                 alt="">
            <div class="menu-list"
                 v-if="show">
                <!-- <span @click="gotoMnq">官网论坛</span> -->
                <span @click="about">关于我们</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false
        }
    },
    methods: {
        gotoMnq() {
            window.location.href = 'https://www.ldmnq.com/forum/forum-41-1.html?type=lastest'
        },
        goto() {
            if(this.$route.name === 'Mobile') return
            this.$router.push({
                name: 'Mobile'
            })
        },
        about() {
            this.$router.push({
                name: 'MobileAbout'
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.mobile-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 128px;
    background: #000;
    padding: 0 42px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 999;
    .nav-logo {
        display: flex;
        align-items: center;
        .img-logo {
            margin-right: 24px;
            width: 80px;
        }
        .img-title {
            width: 276px;
            // height: 78px;
        }
    }
    .nav-menu {
        position: relative;
        img {
            width: 72px;
        }
        .menu-list {
            // background: #000;
            position: absolute;
            bottom: -220px;
            left: -242px;
            display: flex;
            flex-direction: column;
            width: 304px;
            height: 200px;
            span {
                background: rgba(0, 0, 0, 0.8);
                flex: 1;
                display: flex;
                align-items: center;
                padding-left: 68px;
                color: #fff;
                font-size: 36px;
            }
        }
    }
}
</style>
